import {
  DEFAULT_ANCHOR_BY_TYPE,
  ElementState,
  ElementType,
  THICKNESS_PRESETS,
  Triangle,
} from '@ritabygglov/core';

export {
  computeTriangleAngles,
  computeTriangleVertices,
} from '../../helpers/triangleGeometry';

export const createTriangle = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string
): Triangle => {
  return {
    id,
    type: ElementType.Triangle,
    text: ' ',
    pointRatio: 0.5,
    x: initialX,
    y: initialY,
    width: 100,
    height: 100,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    style: {
      fill: 'transparent',
      stroke: '#000',
    },
    thickness: THICKNESS_PRESETS.M,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Triangle],
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    diagonalHatch: false,
  };
};
